import Cookies from 'js-cookie';
import propertyUtils from './propertyUtils';
import queryUtils from './queryUtils';

// @ts-ignore
export const shouldDisplayResources = (displayMFHResources, displayMainResources) =>
  displayMFHResources || displayMainResources;

// logic to display menu labels
export const shouldDisplayDropdownLabelHelp = (
  // @ts-ignore
  displayMFHResources,
  // @ts-ignore
  displayMainResources,
  // @ts-ignore
  displayMainHelp,
  // @ts-ignore
  displayAccessMainContactSupport,
) => {
  return displayMFHResources || displayMainResources || displayMainHelp || displayAccessMainContactSupport;
};

export const getPaymentsPath = ({
  paymentsAcceptedCount,
  paymentsGetStartedPage,
  rentPaymentPage,
  paymentsAggregatePage,
}: {
  paymentsAcceptedCount: number;
  paymentsGetStartedPage: string;
  rentPaymentPage: string;
  paymentsAggregatePage: string;
}) => {
  if (paymentsAcceptedCount === 0) {
    return paymentsGetStartedPage;
  }
  if (paymentsAcceptedCount === 1) {
    return rentPaymentPage;
  } else return paymentsAggregatePage;
};
export const ZRMUtils = {
  isEmptyOrNull: (value: string) => {
    return value === '' || value === null;
  },
  /*
   * Checks cookies and query search param against hostApp and
   * returns if the context is in a mobile web view
   *
   * @param search - the query search param (?param_1=value&param_2=value)
   * @return boolean
   */
  isInMobileWebView: (search: string) => {
    const HOST_APP = 'hostApp';
    const IOS = 'ios';
    const ANDROID = 'android';

    let response = false;

    // check cookie
    const hostAppVal = Cookies.get(HOST_APP);
    if (hostAppVal === ANDROID || hostAppVal === IOS) {
      // cookie exists
      response = true;
    } else {
      // check search query param
      const queryParamObj = queryUtils.parse(search);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const queryParamVal = (<any>queryParamObj)[HOST_APP];

      if (queryParamVal === ANDROID || queryParamVal === IOS) {
        // set cookie
        Cookies.set(HOST_APP, queryParamVal);
        response = true;
      }
    }

    return response;
  },
  /**
   * Recursively checks a function
   *
   * @params
   *  @delay - delay for interval
   *  @maxTries - maximum number of tries
   *  @detectFunc - function to check against
   *
   * @return value from function or false if no value can be detected
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recursiveDetection: (params: any, callback: any) => {
    const { delay, maxTries, detectFunc } = params;

    let timer: NodeJS.Timeout | null = null;
    let counter = 0;

    timer = setInterval(() => {
      const response = detectFunc();

      if (response) {
        callback(response);
        timer && clearInterval(timer);
        return;
      }

      // exceeded number of attempts
      if (counter >= maxTries) {
        callback(false);
        timer && clearInterval(timer);
        return;
      }

      counter++;
    }, delay);
  },
  propertyUtils,
  queryUtils,
};
